import { Modal } from "@/frontend/shared/ui/Modal";
import styles from "./AddExpertModal.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";
import { Input } from "@/frontend/shared/ui/Input";
import { useState } from "react";
import { reportErrorToSentry } from "@/frontend/shared/lib/reportErrorToSentry/reportErrorToSentry";
import { NormalButton } from "@/frontend/shared/ui/Button";
import { snackbarConstructor } from "@/frontend/shared/ui/CustomNotifications/ui/Snackbar/snackbarConstructor";
import { postInviteAnExpert } from "../model/services/postInviteAnExpert";
import { AxiosError } from "axios";
import { validateEmail } from "@/frontend/shared/lib/validations/validateEmail";

export function AddExpertModal({
  isOpen,
  onClose,
  triggerRefetch,
  companyId
}: {
  isOpen: boolean;
  onClose: () => void;
  triggerRefetch?: () => void;
  companyId: number;
}) {
  const [email, setEmail] = useState("");
  const [isSendingInvite, setIsSendingInvite] = useState(false);

  const onCloseModal = () => {
    setEmail("");
    setIsSendingInvite(false);
    onClose();
  };

  async function onSendInvite() {
    const error = validateEmail({ email });
    if (error) {
      snackbarConstructor(error, "error");
      return;
    }

    setIsSendingInvite(true);
    try {
      await postInviteAnExpert({ email, portfolioCompanyIds: [companyId] });
      snackbarConstructor(`Sent invite to ${email}`, "normal");
    } catch (error) {
      console.log(error);
      snackbarConstructor("Error sending invite", "error");
      const axiosError = error as AxiosError<{ message: string }>;
      const errorMessage = axiosError.response?.data?.message || "Can't send invite";
      snackbarConstructor(errorMessage, "error");
      reportErrorToSentry(axiosError, "ADD EXPERT MODAL : /organizations/invite/expert");
    } finally {
      triggerRefetch?.();
      onClose();
      setIsSendingInvite(false);
      setEmail("");
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onCloseModal} title="Add Expert" className={styles.modal} width="560px">
      <div className={styles.container}>
        <div>
          <Typography variant="body-2" color="greyscale700" className={styles.description}>
            Experts will receive an email with instructions on how to sign up and join your organization.
          </Typography>
          <Input placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} inputSize="small" />
        </div>
        <div className={styles.bottomContainer}>
          <div className={styles.bottomDivider} />
          <NormalButton onClick={onSendInvite} className={styles.btn} size="large" isSubmitting={isSendingInvite}>
            Send invite
          </NormalButton>
        </div>
      </div>
    </Modal>
  );
}
